import * as React from 'react';

import { cn } from '../../../lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-8 w-full rounded-md border border-control-border bg-control px-2 py-1 text-sm text-control-foreground transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-control-foreground placeholder:text-input-placeholder focus-visible:border-focus focus-visible:outline-none aria-[invalid=true]:border-control-border-error aria-[invalid=true]:focus-visible:border-focus disabled:cursor-not-allowed disabled:border-control-border disabled:bg-control-disabled disabled:text-control-disabled-foreground',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
